export function computeCurrentSlide(slideIndex, slidesCount) {
    let currentSlide;

    if (slideIndex < 0) {
        // Pre-cloned slides
        currentSlide = slidesCount - 1;
    } else if (slideIndex >= slidesCount) {
        // Post-cloned slides
        currentSlide = 0;
    } else {
        // Origin slides
        currentSlide = slideIndex;
    }

    return currentSlide;
}
